import api, { apiData } from "../utils/api";
import { serviceError } from "../lib/serviceError";
import { getLeadID } from "../utils/storage";
import { ORDER_ID_LOCAL_STORAGE_KEY } from "../Constants/constant";

class AfterOnboardAPI {
  // Loan Approved API
  async loanApprovedAPI(emiData) {
    try {
      const endpoint = "/customer_onboarding/approval-viewV2";
      const req = {
        leadID: Number(localStorage.getItem("leadID")),
        productID: emiData.ProductID,
        amount: emiData.AmountDetails.Amount,
        tenureDays: emiData.TenureDetails.Tenure,
      };

      const { data } = await api.post(endpoint, req);
      return data;
    } catch (error) {
      serviceError(error);
    }
  }

  // Approved Bank Account API
  async getApprovedBankAccountAPI() {
    try {
      const endpoint = `/customer-bank-account/closed?leadId=${Number(localStorage.getItem("leadID"))}`;
      const req = {};

      const { data } = await api.get(endpoint, req);
      return data;
    } catch (error) {
      serviceError(error);
    }
  }

  // Add Reference API
  async addReferenceAPI(values) {
    try {
      const endpoint = "/customer_onboarding/reference";
      const req = {
        name1: values.nameOne,
        name2: values.nameTwo,
        mobileNo1: values.mobileOne,
        mobileNo2: values.mobileTwo,
        relation1: values.relationOne,
        relation2: values.relationTwo,
        leadID: Number(localStorage.getItem("leadID")),
      };

      const { data } = await api.post(endpoint, req);
      return data;
    } catch (error) {
      serviceError(error);
    }
  }

  // Selfie Verification API
  async selfieVerificationAPI(image) {
    try {
      const endpoint = "/customer_onboarding/verify_selfie";

      const formData = new FormData();

      formData.append("image", image);
      formData.append("leadID", Number(localStorage.getItem("leadID")));

      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      const { data } = await api.post(endpoint, formData, config);
      return data;
    } catch (error) {
      serviceError(error);
    }
  }

  // Selfie selfie_liveness API
  async selfieLivenessAPI(image) {
    try {
      const endpoint = "customer_onboarding/selfie_liveness";

      const formData = new FormData();

      formData.append("image", image);
      formData.append("leadID", Number(localStorage.getItem("leadID")));

      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      const { data } = await api.post(endpoint, formData, config);
      return data;
    } catch (error) {
      throw error;
    }
  }

  // Get Bank Details API
  async getBankDetailsAPI() {
    try {
      const req = {
        url: "/customers/finbox-account-details",
        method: "GET",
        data: {},
      };

      const res = await apiData(req);
      return res;
    } catch (error) {
      console.log("Error getting in finbox account details", error);
    }
  }

  // Add Bank Details API
  async addBankDetailsAPI(values) {
    try {
      const endpoint = "/customer-bank-account/bank-details";
      const req = {
        accountHoldersName: values.accountHolderName,
        accountNo: `${values.accountNo}`,
        confirmedAccountNo: `${values.confirmedAccountNo}`,
        ifsc: values.ifsc,
        bankName: values.bankName,
        leadID: Number(localStorage.getItem("leadID")),
      };

      const { data } = await api.post(endpoint, req);
      return data;
    } catch (error) {
      serviceError(error);
    }
  }

  // Get Name with IFSC
  async getBankNameWithIFSC(ifsc) {
    try {
      const endpoint = `/common/bank-details?ifsc=${ifsc}`;
      const req = {};

      const { data } = await api.get(endpoint, req);

      return data;
    } catch (error) {
      serviceError(error);
    }
  }

  // Get Customer Bank Account API
  async getCustomerBankAccountAPI(id) {
    try {
      const req = {
        url: `/customer-bank-account/${id}`,
        method: "GET",
        data: {},
      };

      const res = await apiData(req);
      return res;
    } catch (error) {
      console.log("Error getting in customer bank account details", error);
    }
  }

  // Update Customer Bank Account API
  async updateCustomerBankAccountAPI(id, values) {
    try {
      const req = {
        url: `/customer-bank-account/${id}`,
        method: "PUT",
        data: {
          accountHoldersName: values.accountHolderName,
          accountNo: values.accountNo,
          confirmedAccountNo: values.confirmedAccountNo,
          ifsc: values.ifsc,
          bankName: values.bankName,
          leadID: Number(localStorage.getItem("leadID")),
        },
      };

      const res = await apiData(req);
      return res;
    } catch (error) {
      console.log("Error getting in customer bank account update", error);
    }
  }

  // Set Emandate
  async setEmandate(accountId) {
    try {
      const endpoint = "/customer_onboarding/set-emandate";
      const req = {
        accountId: accountId,
        leadID: Number(localStorage.getItem("leadID")),
      };

      const { data } = await api.post(endpoint, req);

      return data;
    } catch (error) {
      serviceError(error);
    }
  }

  // Set Emandate V2 Callback
  async setEmandateV2(accountId) {
    try {
      const endpoint = "/customer_onboarding/set-emandateV2";
      const orderId = localStorage.getItem(ORDER_ID_LOCAL_STORAGE_KEY);
      const req = {
        accountId: accountId,
        leadID: Number(localStorage.getItem("leadID")),
        ...(orderId && { orderId }),
      };

      const { data } = await api.post(endpoint, req);

      return data;
    } catch (error) {
      throw error;
    }
  }

  //Get penny-flow
  async getPennyFlowAPI() {
    try {
      const endpoint = `customer_onboarding/penny-flow?leadId=${Number(localStorage.getItem("leadID"))}`;
      const req = {};

      const { data } = await api.get(endpoint, req);

      return data;
    } catch (error) {
      serviceError(error);
    }
  }

  // Penny Drop
  async pennyDrop(accountId) {
    try {
      const endpoint = "/customer_onboarding/penny-drop";
      const req = {
        accountId: accountId,
        leadID: Number(localStorage.getItem("leadID")),
      };

      const { data } = await api.post(endpoint, req);

      return data;
    } catch (error) {
      // serviceError(error);
      throw error;
    }
  }

  // Customer Bank Account
  async customerBankAccountAPI() {
    try {
      const endpoint = `/customer-bank-account?leadId=${Number(localStorage.getItem("leadID"))}`;
      const req = {};

      const { data } = await api.get(endpoint, req);

      return data;
    } catch (error) {
      serviceError(error);
    }
  }

  // Confirm Bank Account
  async confirmBankAccountAPI(mandateId, accountID) {
    const req = {
      url: "/customer-bank-account/confirm",
      method: "POST",
      data: {
        leadID: Number(localStorage.getItem("leadID")),
        mandateId: Number(mandateId),
        accountID: accountID,
      },
    };

    const res = await apiData(req);

    return res;
  }

  // Key Fact Statement
  async keyFactStatementsAPI() {
    try {
      const endpoint = `/customer_onboarding/kfs-payday?leadId=${getLeadID()}`;
      const req = {};

      const { data } = await api.get(endpoint, req);

      return data;
    } catch (error) {
      serviceError(error);
    }
  }

  // Key Fact Acceptance
  async keyFactAceeptanceAPI({ otp = null, latitude, longitude }) {
    try {
      const endpoint = `/customer_onboarding/kfs-facts-acceptance`;
      const req = {
        leadId: Number(localStorage.getItem("leadID")),
        otp,
        latitude,
        longitude
      };

      const { data } = await api.post(endpoint, req);

      return data;
    } catch (error) {
      serviceError(error);
    }
  }

  // One Page Get Details
  async onePageGetDetailsAPI() {
    try {
      const endpoint = `/customers/one-page/${getLeadID()}`;
      const req = {};

      const { data } = await api.get(endpoint, req);

      return data;
    } catch (error) {
      serviceError(error);
    }
  }

  // Check Repeat Case
  async checkRepeatCaseAPI(values) {
    const host = window.location.href.split("/");

    try {
      const endpoint = `/customers/check-repeat-case/${getLeadID()}`;
      const req = {
        // loanRequeried: loanAmount,
        loanPurpose: values.loanPurpose,
        // marrital: values.maritalStatus,
        // education: values.qualification,
        employeeType: values.employementType,
        modeOfPayment: values.modeOfPayment,
        // companyName: values.companyName,
        // industry: values.industry,
        // designation: values.designation,
        monthlyIncome: values.monthlySalary,
        salary_date: values.salaryDate,
        // residenceType: values.address.type,
        callBackUrl: host[0] + "//" + host[2] + "/finbox",
        ... (values.monthlyIncomeConsent && { monthlyIncomeConsent: values.monthlyIncomeConsent })
      };

      const { data } = await api.post(endpoint, req);

      return data;
    } catch (error) {
      serviceError(error);
    }
  }

  // Get Lender Payment Details
  async getLenderPaymentDetailsAPI() {
    const leadId = Number(localStorage.getItem("leadID"));
    try {
      const endpoint = `lender/get-lender-creds?leadID=${leadId}`;
      const req = {};
      const { data } = await api.get(endpoint, req);
      return data;
    } catch (error) {
      console.log(error);
    }
  }

  // Get My Loans API
  async getMyLoansAPI() {
    try {
      const customerID = Number(localStorage.getItem("customerID"));
      const endpoint = `customers/${customerID}/customer-loans`;
      const req = {};

      const { data } = await api.get(endpoint, req);
      return data;
    } catch (error) {
      serviceError(error);
    }
  }

  // Get Sanction PDF API
  async getSanctionPdfAPI(leadID, isSendMail = 0, type) {
    const customerID = Number(localStorage.getItem("customerID"));
    try {
      const endpoint = `customers/checkSectionPdf?leadID=${leadID}&customerID=${customerID}&isSendMail=${isSendMail}&type=${type}`;
      const req = {};

      const { data } = await api.get(endpoint, req);
      return data;
    } catch (error) {
      serviceError(error);
    }
  }

  // Add comment feedback API
  async feedbackAPI(payload) {
    try {
      const endpoint = "customers/feedback";
      const { data } = await api.post(endpoint, payload);

      return data;
    } catch (error) {
      serviceError(error);
    }
  }

  // Get Hyperverge Feature
  async getHypervergeFeatureAPI() {
    try {
      const endpoint = `customers/hyperverge-feature`;
      const req = {};

      const { data } = await api.get(endpoint, req);
      return data;
    } catch (error) {
      serviceError(error);
    }
  }

  // Selfie hyperverge  API
  async selfieHyperverge() {
    try {
      const endpoint = "customer_onboarding/hyperverge/start-onboarding";

      const req = {
        leadID: localStorage.getItem("leadID"),
      };
      const { data } = await api.post(endpoint, req);

      return data;
    } catch (error) {
      // serviceError(error);
      throw error;
    }
  }

  // Selfie hyperverge result  API
  async selfieHypervergeResult() {
    try {
      const endpoint = "customer_onboarding/hyperverge/result";

      const req = {
        transactionId: localStorage.getItem("leadID"),
      };
      const { data } = await api.post(endpoint, req);

      return data;
    } catch (error) {
      // serviceError(error);
      throw error;
    }
  }
}

export default AfterOnboardAPI;
